import React, { useState } from "react";
import Button from "devextreme-react/button";
import ValidationSummary from "devextreme-react/validation-summary";
import Form, {
  SimpleItem,
  ColCountByScreen,
  GroupItem,
  Tab,
  TabPanelOptions,
  Label,
  TabbedItem,
  ButtonItem,
} from "devextreme-react/form";

const downloadFile = async (myData) => {
  // const {myData} = this.state; // I am assuming that "this.state.myData"
  // is an object and I wrote it to file as
  // json
  const fileName = myData.owners[0].firstName + " " + myData.owners[0].lastName;
  const json = JSON.stringify(myData);
  const blob = new Blob([json], { type: "application/json" });
  const href = await URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = href;
  link.download = fileName + ".json";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const FRM = React.createRef();

const findNodeById = (nodes, id) => {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i]["_uid"].includes(id)) {
      return nodes[i];
    }

    if (nodes[i].fields) {
      const node = findNodeById(nodes[i].fields, id);
      if (node != null) {
        return node;
      }
    }
  }
  return null;
};

function visibleFunction(obj, values) {
  try {
    let ans = eval(obj);
    if (ans == false) {
      return false;
    } else {
      return true;
    }
    return ans;
  } catch {
    return false;
  }

  return Function('"use strict";return (' + obj + ")")();
}

const onSubmit = (e) => {
  e.preventDefault();
  // todo - send data somewhere
};

const Aggreement = ({ pageLayout, data, Aggkey }) => {
  const getField = (dataForField, key, values) => {
    var opt = {
      dataField: { key },
      key: { key },
      rtlEnabled: true,
      items: dataForField.Value.split("|"),

      multiline: true,
      validationRules: [
        {
          type: "required",
          message: "Name is required",
        },
      ],

      visible: visibleFunction(
        dataForField.visible ? dataForField.visible.toString() : "true",
        values
      ),
      onValueChanged: (e) => {
        UseForceUpdate(); //working but jumps to the begining of page
        //fieldChanged(e); // WORK but jumps to the begining of page
        //setEmployee(e.component.option("formData")); //NOT WORKING
        //setEmployee (FRM.current._instance.option("formData")); //NOT WORKING
        // setVisible('true');
      },
    };

    if (dataForField._uid) {
      switch (dataForField.Type) {
        case "TextStat":
          return (
            <GroupItem key={key} colSpan={4}>
              <p>{dataForField.caption}</p>
            </GroupItem>
          );
          break;
        case "Header":
          return (
            <GroupItem key={key} colSpan={4}>
              <h3>{dataForField.caption}</h3>
            </GroupItem>
          );
          break;
        case "Header2":
          return (
            <GroupItem key={key} colSpan={4}>
              <h4>{dataForField.caption}</h4>
            </GroupItem>
          );
          break;
        case "Label":
          return (
            <GroupItem key={key} colSpan={4}>
              <h5>{dataForField.caption}</h5>
            </GroupItem>
          );
          break;

        case "RadioGroup":
          //   opt = opt.push({items:data.Value.split("|")})

          return (
            <GroupItem key={"grp" + key}>
              <SimpleItem
                editorType="dxRadioGroup"
                editorOptions={opt}
                dataField={key}
                key={key}
                validationRules={[
                  {
                    type: "required",
                    message: "Name is required",
                  },
                ]}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );

          break;

        // case "SelectBoxMulti":
        //   let ds = data.Value.split("|")

        //   return (

        //       <SimpleItem editorType="dxDropDownBox"
        //         dataSource={ds}

        //         dataField={key} key={key}
        //         validationRules={[
        //           {
        //             type: "required",
        //             message: "Name is required"
        //           }
        //         ]}

        //       >
        //         <Label text={data.caption} />
        //       </SimpleItem>

        //   )

        //     // <GroupItem  key={"grp"+key} >
        //     //   <div className="dx-field">
        //     //     <div className="dx-field-label">{data.caption}</div>
        //     //     <div className="dx-field-value">
        //     //       <TagBox   dataField={key} key={key} items={data.Value.split("|")}
        //     //         showSelectionControls={true}
        //     //         validationRules={ [
        //     //           {
        //     //             type: "required",
        //     //             message: "Name is required"
        //     //           }
        //     //         ]}
        //     //         applyValueMode="useButtons"  />
        //     //     </div>
        //     //   </div>

        //     // </GroupItem>)
        //   break;

        default:
          return (
            <GroupItem>
              <SimpleItem
                editorType="dxTextBox"
                visible={eval("values.owners[0].pep == 'כן'")}
                editorOptions={opt}
                validationRules={[
                  {
                    type: "required",
                    message: "Name is required",
                  },
                ]}
                dataField={key}
                key={key}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );
          break;
      }

      return (
        <SimpleItem editorType="dxTextBox" dataField={key} key={key}>
          <Label text={dataForField.caption} />
        </SimpleItem>
      );
    } else {
      return (
        <GroupItem
          caption={dataForField.caption}
          key={"rwsr" + Math.floor(Math.random() * 20000)}
        >
          <p>{dataForField.caption}</p>
        </GroupItem>
      );
    }
  };

  const getTabs = (field, fields, key, values) => {
    return (
      <Tab title={field.firstName || "new "} colCount={1} key={"tab" + key}>
        {fields.map(function (item) {
          return getField(item, key + item._uid, values);
        })}

        <ButtonItem
          horizontalAlignment="right"
          buttonOptions={{
            text: "הוסף בעל חשבון",
            type: "success",
            onClick: "addOwner",
          }}
        />
      </Tab>
    );
  };

  const [values, setAgre] = useState(data);
  const [template, setTemplate] = useState(pageLayout);
  const [ForceInt, setForce] = useState(0);
  const [vis, setVis] = useState(true);
  const [ownersData, setOwners] = useState(data.owners);
  // var values = data;

  const checkBoxOptions = {
    text: "Show Address",
    // value: true,
    onValueChanged: (e) => {
      UseForceUpdate();
      // setVis(!values.Owner.chbx);

      // setAgre(FRM.current._instance.option("formData"));
    },
  };

  const formFieldDataChanged = (e) => {
    // FRM.current.instance.updateDimensions();
    setAgre(FRM.current._instance.option("formData"));
    //  values.owners.push('');
    setOwners(values.owners);
    UseForceUpdate();
  };

  //Load File
  const handleChange = (e) => {
    const fileReader = new FileReader();
    fileReader.readAsText(e.target.files[0], "UTF-8");
    fileReader.onload = (e) => {
      setAgre(JSON.parse(e.target.result));
    };
  };

  const UseForceUpdate = (e) => {
    // integer state
    //values = FRM.current._instance.option("formData")

    setAgre(FRM.current._instance.option("formData"));
    // values.owners.push('');
    setOwners(values.owners);

    setForce(ForceInt + 1); // update the state to force render
  };

  const addOwner = (e) => {
    values.owners.push({});
    setOwners((ownersData) => values.owners);
    setForce(ForceInt + 1);
  };

  const onSaveFile = (e) => {
    //  values = FRM.current._instance.option("formData")

    setAgre(FRM.current._instance.option("formData"));
    downloadFile(values);
    // FRM.current.instance.repaint();
    // FRM.current.instance.updateData(data);

    // UseForceUpdate();
  };

  return (
    <div className={"content-block dx-card responsive-paddings"}>
      <form onSubmit={onSubmit} id="frm">
        <div className="App">
          <input type="file" onChange={handleChange} />
        </div>
        <Form
          onFieldDataChanged={formFieldDataChanged}
          deferRendering={false}
          // formData={customer}
          id="FRM"
          ref={FRM}
          readOnly={false}
          colCount={1}
          showColonAfterLabel={true}
          showValidationSummary={true}
          alignItemLabels={true}
          alignItemLabelsInAllGroups={true}
          formData={values}
        >
          <GroupItem colCount={4}>
            <ButtonItem
              horizontalAlignment="right"
              buttonOptions={{
                text: "הוסף בעל חשבון",
                type: "success",
                onClick: addOwner,
              }}
            />

            <ButtonItem
              horizontalAlignment="right"
              buttonOptions={{
                text: "טען קובץ",
                type: "file",
                onClick: handleChange,
              }}
            />
          </GroupItem>

          <TabbedItem colCount={2} key={"tabAlltabGroup"}>
            <TabPanelOptions deferRendering={false} />
            <ColCountByScreen xs={1} sm={2} md={3} />
            <Tab title="בעלי חשבון" colCount={1} key={"tabOwnerAccountsGrp"}>
              <TabbedItem colCount={2} key={"tabOwnerAccouns"}>
                <TabPanelOptions colCount={1} deferRendering={false} />

                {ownersData.map((item, i) =>
                  getTabs(item, template.owner, "owners[" + i + "].", values)
                )}
              </TabbedItem>
            </Tab>

            <Tab title="בירור צרכים" key={"tabNeedAnalsys"}>
              {template.NeadAnalysis.map((field) =>
                getField(field, "needsAnalysis." + field._uid, values)
              )}
            </Tab>

            <Tab title="פרטי הסכם" colCount={4} key={"tabAgreement"}>
              {template.agreement.map((field) =>
                getField(field, field._uid, values)
              )}
            </Tab>

            <Tab title="חשבונות" colCount={1} key={"tabAccounts"}>
              <TabbedItem colCount={1} key={"tabtabGroup"}>
                <TabPanelOptions colCount={1} deferRendering={false} />
                {values.accounts.map((item, i) =>
                  getTabs(
                    item,
                    template.account,
                    "accounts[" + i + "].",
                    values
                  )
                )}
              </TabbedItem>
            </Tab>
          </TabbedItem>

          <ButtonItem
            horizontalAlignment="left"
            onClick={onSaveFile}
            text="SAVE"
            buttonOptions={{
              text: "Save",
              type: "success",
              onClick: onSaveFile,
            }}
          />

          <GroupItem>
            <GroupItem caption="Personal Data">
              <SimpleItem
                editorType="dxCheckBox"
                dataField={"Owner.chbx"}
                editorOptions={checkBoxOptions}
              />
            </GroupItem>
            <GroupItem>
              <SimpleItem
                editorType="dxTextBox"
                dataField={"Owner.firstName"}
                visible={visibleFunction("values.Owner.chbx == true")}
              />
            </GroupItem>
          </GroupItem>
        </Form>

        <div className="dx-fieldset">
          <ValidationSummary id="summary"></ValidationSummary>
          <Button
            id="button"
            text="Register"
            type="success"
            useSubmitBehavior={true}
          />
        </div>
      </form>
    </div>
  );
};

export default Aggreement;
